import { render, staticRenderFns } from "./StepsAuto.vue?vue&type=template&id=72d24126&scoped=true&"
import script from "./StepsAuto.vue?vue&type=script&lang=js&"
export * from "./StepsAuto.vue?vue&type=script&lang=js&"
import style0 from "./StepsAuto.vue?vue&type=style&index=0&id=72d24126&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d24126",
  null
  
)

export default component.exports